<template>
  <div>
    <div class="content-notes-section mt-4">
      <!-- YOUR FIRST V-FOR LOOP WILL BE DONE FROM THIS CLASS ROW AND THE SECOND ONE WILL BE DONE ON THE DOCUMENT CARD COMPONENT  -->

      <div
        class="row section-divider"
        v-for="(term, index) in notes"
        :key="index"
      >
        <!-- TERM INTRO -->
        <div class="col-12"><TermTitleIntro :term_week="term.date" /></div>
        <!-- TERM INTRO -->
        <div class="col-12">
          <!-- DOCUMENT CARD -->
          <DocumentCard
            v-for="(data, index) in term.data"
            :key="index"
            :id="data.id"
            :file="data.filename"
            :file_name="data.title"
            :file_type="data.extension"
            :file_types="data.filetype"
            :file_date="formatFileDate(data.created_at)"
            :file_time="formatFileTime(data.created_at)"
            :file_author_detail="data.user"
            :file_token="data.token"
            :file_extension="data.extension"
            :is_owner="data.isOwner"
            :user_data="data.user"
            :show_box_shadow="false"
            :subscription_status="subscription_status"
          ></DocumentCard>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import { formatDate, formatTime } from "@/scripts/utilities";

export default {
  name: "ContentNotes",

  components: {
    DocumentCard: () =>
      import(
        /* webpackChunkName: "DocumentCard" */
        "@/components/classComps/library/DocumentCard"
      ),
    TermTitleIntro: () =>
      import(
        /* webpackChunkName: "TermTitleIntro" */
        "@/components/classComps/library/TermTitleIntro"
      ),
  },

  props: {
    notes: Array,
    subscription_status: Boolean,
  },

  methods: {
    formatFileDate(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatDate(new_date);
    },

    formatFileTime(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatTime(new_date);
    },
  },
};
</script>

<style lang="scss">
.content-notes-section {
  .section-divider {
    margin-bottom: 35px;
  }
}
</style>